<script>
	// From Lucide
	import { MoreHorizontal } from 'lucide-svelte';

	export let iconClass = '';
</script>

<MoreHorizontal class={iconClass} />